import { render, staticRenderFns } from "./reporte-detalle-producto.vue?vue&type=template&id=b955bb10&scoped=true"
import script from "./reporte-detalle-producto.vue?vue&type=script&lang=js"
export * from "./reporte-detalle-producto.vue?vue&type=script&lang=js"
import style0 from "./reporte-detalle-producto.vue?vue&type=style&index=0&id=b955bb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b955bb10",
  null
  
)

export default component.exports